import type { LearningProgress as LearningProgressData } from '@mathflat/domain/StudentHistory'
import { makeAutoObservable } from 'mobx'

import ExtendedMap from '@/models/ExtendedMap'

import { LearningProgress } from './LearningProgress'

export class LearningProgressColl {
  map: ExtendedMap<LearningProgress['clientId'], LearningProgress>

  constructor(learningProgresses: LearningProgressData[]) {
    makeAutoObservable(this)

    const arr = learningProgresses.map((data) => new LearningProgress(data))
    this.map = ExtendedMap.fromArr(arr, 'clientId')
  }

  get toArr() {
    return [...this.map.values()]
  }

  get isEmpty() {
    return this.map.isEmpty
  }

  clear() {
    this.map.clear()
  }
}
